import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import NProgress from "nprogress";



Vue.use(Router);


const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/angebote/aktiv",
      name: "angebote",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListAktive.vue")
    },
    {
      path: "/angebote/freigeben",
      name: "angeboteFreigeben",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListFreigeben.vue")
    },
    {
      path: "/angebote/inaktive",
      name: "angeboteInaktive",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListInaktive.vue")
    },
    {
      path: "/angebote/abgelehnt",
      name: "angeboteAbgelehnt",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListAbgelehnt.vue")
    },
    {
      path: "/angebote/inBearbeitung",
      name: "angeboteBearbeitung",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListBearbeitung.vue")
    },
    {
      path: "/angebote/neu",
      name: "angeboteNeu",
      props: true,
      linkActiveClass: "active",

      component: () =>
          import("./views/Angebote/Create.vue")
    },
    {
      path: "/angebote/detail/:id",
      name: "angebotShow",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./components/angebot/admin/Show.vue")
    },
    {
      path: "/angebote/bearbeiten/:id",
      name: "angebotBearbeiten",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/Edit.vue")
    },
    {
      path: "/angebote/suche",
      name: "suche",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/Suche.vue")
    },
    {
      path: "/angebote/merkliste",
      name: "merkliste",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/Merkliste.vue")
    },
    {
      path: "/angebote/meineliste",
      name: "meineliste",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/ListVermieter.vue")
    },
    {
      path: "/settings",
      name: "settings",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./components/Settings.vue")
    },
    {
      path: "/system-messages-vermieter",
      name: "systemMessagesVermieter",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/SystemMessagesVermieter.vue")
    },
    {
      path: "/system-messages-mieter",
      name: "systemMessages",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/SystemMessagesMieter.vue")
    },
    {
      path: "/login",
      name: "login",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/Login.vue")
    },
    {
      path: "/registerSuchend",
      name: "registerSuchend",
      linkActiveClass: "active",
      props: {
        default: true,
        type: 1
      },
      component: () =>
          import("./views/User/RegisterMieter.vue")
    },
    {
      path: "/registerVermieter",
      name: "registerVermieter",
      linkActiveClass: "active",
      props: {
        default: true,
        type: 2
      },
      component: () =>
          import("./views/User/RegisterVermieter.vue")
    },
    {
      path: "/logout",
      name: "logout",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/Logout.vue")
    },
    {
      path: "/profil",
      name: "profil",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/Account.vue")
    },
    {
      path: "/profil-vermieter",
      name: "profilVermieter",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/AccountVermieter.vue")
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/Reset.vue")
    },
    {
      path: "/newPassword",
      name: "newPassword",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/NewPassword.vue")
    },
    {
      path: "/activateUser",
      name: "activateUser",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/ActivateUser.vue")
    },
    {
      path: "/pdf",
      name: "pdf",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Angebote/PDF.vue")
    },
    {
      path: "/statistik",
      name: "statistik",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/User/Statistik.vue")
    },
    {
      path: "/benutzerverwaltung",
      name: "benutzerverwaltung",
      linkActiveClass: "active",
      component: () =>
          import("./views/Benutzerverwaltung.vue")
    },
    {
      path: "/benutzerverwaltung-user",
      name: "benutzerverwaltung-single",
      linkActiveClass: "active",
      props: true,
      component: () =>
          import("./views/Benutzerverwaltung-Single.vue")
    },
    {
      path: "/datenschutz",
      name: "datenschutz",
      linkActiveClass: "active",
      component: () =>
          import("./views/Datenschutz")
    },
    {
      path: "/impressum",
      name: "impressum",
      linkActiveClass: "active",
      component: () =>
          import("./views/Impressum")
    },
    {
      path: "/agb",
      name: "agb",
      linkActiveClass: "active",
      component: () =>
          import("./views/AGB")
    },
    {
      path: "/nutzerbedingungen",
      name: "nutzerbedingungenMieter",
      linkActiveClass: "active",
      component: () =>
          import("./views/NutzerbedingungenMieter")
    },
    {
      path: "/nutzerbedingungenVermieter",
      name: "nutzerbedingungenVermieter",
      linkActiveClass: "active",
      component: () =>
          import("./views/NutzerbedingungenVermieter")
    }
  ]
})


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/registerSuchend', '/registerVermieter', '/resetPassword', '/newPassword', '/datenschutz', '/agb', '/impressum', '/nutzerbedingungenVermieter', '/nutzerbedingungen'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router